import React from 'react'

import ActionPlansAccordion from './actionPlans/ActionPlansAccordion'
import ChildrenRepliesAccordion from './replies/ChildrenRepliesAccordion'
import ChildrenServiceOrderLoader from './_load/ChildrenServiceOrderLoader'
import FlexGrid from '../../../components/structure/FlexGrid'
import GeneralAccordion from './general/GeneralAccordion'
import LazyLoad from '../../../packages/kiti/components/helpers/LazyLoad'
import NonCompliancesAccordion from './nonCompliances/NonCompliancesAccordion'
import PendenciesAccordion from './pendencies/PendenciesAccordion'
import RepliesAccordion from './replies/RepliesAccordion'
import * as tracker from '@btime/tracker'

const ResumePageContent = ({ id }) => {
  tracker.viewedTaskSumary()
  return (
    <div>
      <FlexGrid align="stretch" direction="column" paddingGutter={0.6}>
        <GeneralAccordion />
        <ActionPlansAccordion />
        <PendenciesAccordion />
        <NonCompliancesAccordion />
        <RepliesAccordion />
        <LazyLoad>
          <ChildrenServiceOrderLoader parentId={id}>
            <ChildrenRepliesAccordion />
          </ChildrenServiceOrderLoader>
        </LazyLoad>
      </FlexGrid>
    </div>
  )
}

export default ResumePageContent
